import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';

import { Button, Dialog, DialogContent, DialogTitle, LinearProgress, TextField } from '@mui/material';

import API from 'app/API';
import Captcha from 'utils/Captcha';

const recaptchaRef = React.createRef();

@inject('userStore')
@inject('dialogStore')
@observer
class Login extends React.Component {
    static propTypes = {
        userStore: PropTypes.any,
        dialogStore: PropTypes.any
    };

    state = {
        username: '',
        password: '',
        errorText: '',
        loading: false,
        showCaptcha: true
    };

    handleEnterKey = (e) => {
        if (e.charCode === 13) {
            this.onLogin();
        }
    };

    handleChange = (e) => this.setState({ [e.target.name]: e.target.value });

    onLogin = () => {
        this.setState({ loading: true });
        API.fetchWithToken(API.LOGIN, {
            username: this.state.username,
            password: this.state.password,
            captcha: this.state.showCaptcha && recaptchaRef.current.getValue()
        }).then((response) => {
            let error = response.result === 'error' ? response.data.error : '';

            if (error && response.data.errorCode === 118) {
                error = `User is not activated. \n Follow instructions in email or click RECOVER PASS`;
            }

            if (response.result === 'OK') {
                this.props.userStore.loadUser();
                this.props.userStore.loadLicenseList();
                this.props.userStore.loadSubscriptions();
                this.props.dialogStore.closeAll();
            }

            this.setState({
                loading: false,
                errorText: error,
                showCaptcha: response.data.errorCode === API.errors.NEED_CAPTCHA
            });
        });
    };

    render() {
        const { dialogStore } = this.props;
        const { openSignupDialog, openRecoveryDialog, closeAll, loginDialogOpen } = dialogStore;

        return (
            <Dialog maxWidth="xs" open={loginDialogOpen} className="vulners-dialog" onClose={closeAll}>
                <DialogTitle>Login</DialogTitle>
                <DialogContent>
                    <TextField fullWidth name="username" label="Username" onChange={this.handleChange} />
                    <br />
                    <br />
                    <TextField
                        fullWidth
                        name="password"
                        type="password"
                        label="Password"
                        onChange={this.handleChange}
                        onKeyPress={this.handleEnterKey}
                    />
                    <br />
                    <br />
                    {this.state.showCaptcha && <Captcha id="vulners-login-captcha" ref={recaptchaRef} action="login" />}

                    <div className="vulners-dialog-error-text">{this.state.errorText}</div>

                    {this.state.loading && <LinearProgress variant="indeterminate" />}
                    <Button
                        fullWidth
                        color="primary"
                        variant="contained"
                        onClick={this.onLogin}
                        disabled={this.state.loading}
                    >
                        Login
                    </Button>

                    <br />
                    <div className="vulners-divider-20"></div>
                    <div className="display-flex flex-between">
                        <Button onClick={openSignupDialog} disabled={this.state.loading}>
                            Sign Up
                        </Button>

                        <Button onClick={openRecoveryDialog} disabled={this.state.loading}>
                            Recover Pass
                        </Button>
                    </div>
                </DialogContent>
            </Dialog>
        );
    }
}

export default Login;
